'use strict';

var React = require('react');

var SvgOrdersMajor = function SvgOrdersMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 1a1 1 0 1 0-2 0v7.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414l-1.293 1.293v-7.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14v-11h4v-2h-4.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5h-4.5v2h4v11h-3.5c-.775 0-1.388.662-1.926 1.244l-.11.12a1.994 1.994 0 0 1-1.464.636 1.994 1.994 0 0 1-1.463-.637l-.111-.12c-.538-.579-1.151-1.243-1.926-1.243h-3.5z"
  }));
};

exports.SvgOrdersMajor = SvgOrdersMajor;
